<template>
  <div class="page_bd News-area">
    <secBanner></secBanner>
    <div class="breadcrumb-nav">
      <div class="container">
        您现在的位置：
        <router-link to="/">首页</router-link>
        >
        <router-link :to="{ path: '/news', query: { tab: 0 } }"
          >新闻资讯</router-link
        >
        >
        <router-link to="" v-if="articelTypes.length > 0">{{
          articelTypes[activeIndex].name
        }}</router-link>
      </div>
    </div>
    <div class="container content-area">
      <div class="tabs" :style="'width:' + articelTypes.length * 160 + 'px;'">
        <div
          class="tab"
          :class="{ active: activeIndex == index }"
          :style="'width:' + 100 / articelTypes.length + '%;'"
          @click="
            activeIndex = index;
            getArticleClassify();
          "
          v-for="(item, index) in articelTypes"
          :key="index"
        >
          {{ item.name }}
        </div>
        <!-- <router-link
          class="tab"
          :class="{ active: activeIndex == index }"
          :style="'width:' + 100 / articelTypes.length + '%;'"
          :to="{ path: '/news', query: { tab: index } }"
          v-for="(item, index) in articelTypes"
          :key="index"
        >
          {{ item.name }}
        </router-link> -->
      </div>
      <div class="lead" v-if="articelTypes.length > 0">
        {{ articelTypes[activeIndex].name }}
      </div>
      <div class="list">
        <ul>
          <li v-for="(item, index) in dataList" :key="index">
            <router-link
              class="single"
              :to="{
                name: 'NewsDetail',
                query: {
                  type: item.classifyid,
                  id: item.id,
                  pid: item.classify_parent_id
                }
              }"
            >
              <div class="img">
                <img :src="$imgBaseUrl + item.article_img" alt="" />
              </div>
              <div class="info">
                <div class="title ellipsis">{{ item.title }}</div>
                <div class="intro ellipsis2">{{ item.introduce }}</div>
                <div class="time">{{ item.created_time }}</div>
              </div>
            </router-link>
          </li>
        </ul>

        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="total < listQuery.limit"
          @pagination="getArticleList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import secBanner from "@/components/assembly/sec-banner";
import Pagination from "@/components/assembly/pagination";
export default {
  data() {
    return {
      activeIndex: this.$route.query.tab,
      dataList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 9
      },
      articelTypes: []
    };
  },
  components: {
    secBanner,
    Pagination
  },
  mounted() {
    this.getArticleClassify();
  },
  watch: {
    $route(to, from) {
      if (to.query.tab !== from.query.tab) {
        this.activeIndex = this.$route.query.tab;
        this.getArticleList();
      }
    }
  },
  methods: {
    getArticleClassify() {
      this.$https
        .fetchPost("/Article/classify_list", {
          parent_id: 39
        })
        .then(res => {
          // console.log(res)
          this.articelTypes = res.data;
          this.getArticleList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getArticleList() {
      this.$https
        .fetchPost("/Article/article_list", {
          classifyid: this.articelTypes[this.activeIndex].id,
          page: 1,
          limit: 10
        })
        .then(res => {
          // console.log(res.data.data)
          this.dataList = res.data;
          this.total = res.count;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="less">
.News-area {
  .list {
    .single {
      padding: 30px 0;
      display: flex;
      border-bottom: 1px solid rgba(224, 224, 224, 1);
      &:hover {
        .title {
          color: #028238;
        }
      }
      .img {
        // width: 168px;
        // height: 114px;
        img {
          width: 168px;
          height: 114px;
        }
      }
      .info {
        flex: 1;
        margin-left: 20px;
      }
      .title {
        font-family: MicrosoftYaHei-Bold;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 22px;
        letter-spacing: 0px;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .intro {
        margin: 10px 0 5px;
        height: 44px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 22px;
        letter-spacing: 0px;
        color: rgba(153, 153, 153, 1);
      }
      .time {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 22px;
        letter-spacing: 0px;
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue